import MarkdownText from './MarkdownText';

const renderConversationalCoach = (data) => (
    <div className="conversational-coach">
      <div className="coach-header bg-gradient-to-r from-primary/20 to-accent/20 p-6 rounded-lg border border-primary/30 mb-6">
        <h3 className="text-xl font-bold text-primary mb-2 flex items-center">
          💬 AI Trading Coach
        </h3>
      </div>

      <div className="conversation-thread space-y-4 mb-6">
        <div className="message user-message bg-secondary p-4 rounded-lg ml-8 border border-border">
          <div className="text-sm text-muted-foreground mb-1">You asked:</div>
          <div className="text-foreground">{data.query}</div>
        </div>

        <div className="message coach-message bg-card p-4 rounded-lg mr-8 border border-border">
          <div className="text-sm text-primary mb-2 flex items-center">
            🤖 Your AI Coach responds:
          </div>
          <div className="text-foreground"><MarkdownText>{data.response}</MarkdownText></div>
        </div>
      </div>

      {data.follow_up_suggestions && (
        <div className="follow-up-suggestions">
          <h4 className="text-md font-semibold text-foreground mb-3">Continue the conversation:</h4>
          <div className="flex flex-wrap gap-2">
            {data.follow_up_suggestions.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => handleFollowUp(suggestion)}
                className="px-3 py-2 text-sm bg-primary/20 text-primary rounded-lg hover:bg-primary/30 transition-colors border border-primary/30"
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
export default renderConversationalCoach;